import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Checkbox, Input, Modal, Radio, Row, Spin } from "antd";

import moment from "moment/moment";
import Swal from "sweetalert2";

import ApiService from "../../../apis/ApiService";
import {
  default as CooperateApi,
  default as cooperateApi,
} from "../../../apis/Cooperate.api.js";
import productApi from "../../../apis/Product.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import CooperateTag from "./component/CooperateTag";
import CooperateFeeComponent from "./cooperateRegister/CooperateFeeComponent.jsx";
import CooperateLinkRewardComponent from "./cooperateRegister/CooperateLinkRewardComponent";
import CooperateOptionComponent from "./cooperateRegister/CooperateOptionComponent";
import CooperatePeriod from "./cooperateRegister/CooperatePeriod";
import CooperatePickInfluencer from "./cooperateRegister/CooperatePickInfluencer";
import CooperatePickProduct from "./cooperateRegister/CooperatePickProduct";
import CooperateProductPriceInformation from "./cooperateRegister/CooperateProductPriceInformation";

const api = new ApiService();

const CooperateRegisterComponent = ({ match }) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [isEdit, setIsEdit] = useState(false);

  const [exampleShow, setExampleShow] = useState(false);
  const [exampleTitle, setExampleTitle] = useState({
    id: "",
    title: "",
  });

  // 인플루언서 선택
  const [selectInfluencer, setSelectInfluencer] = useState({
    id: 0,
    nick_name: "",
  });
  // 상품 등록
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // 공구 기간
  const [searchOptions, setSearchOptions] = useState({
    startDate: moment().hour(10).minute(0).seconds(0),
    endDate: moment().add(7, "day").hour(22).minute(0).seconds(0),
  });
  // 공구 기간 수정 기준 (공구 수정 시 기준이 되는 공구 시작일, 마감일)
  const [standardSearchOptions, setStandardSearchOptions] = useState({
    startDate: moment(),
    endDate: moment(),
  });
  // 리워드, 기존 판매가
  const [cooperate, setCooperate] = useState({
    commission_rate: 0,
    dy_commision_include: true,
    price_1: null,
  });
  // 상품 옵션 목록
  const [productOptions, setProductOptions] = useState([
    {
      option_title: "[N%, 1+1] N박스 (N개월분)",
      price_2: 0,
      option_quantity: 1,
      conversion_price_per_unit: null,
      quantity: 999,

      // 태그 추가
      tag_name: null,
      tag_background_color: null,
      tag_text_color: null,
    },
  ]);
  // 기존 옵션 목록
  const [optionList, setOptionList] = useState([]);
  // 순서 진행에 따른 step
  const [step, setStep] = useState(0);

  const [isSoldOut, setIsSoldOut] = useState(false);

  const [productItemCooperate, setProductItemCooperate] = useState({});
  const [participationCooperate, setParticipationCooperate] = useState({});
  const [returnQuery, setReturnQuery] = useState({});
  const [cooperateQuery, setCooperateQuery] = useState(null);
  const [cooperateTitle, setCooperateTitle] = useState("");
  const [cooperateTagsList, setCooperateTagsList] = useState([]);
  const [isFirstPurchaseEvent, setIsFirstPurchaseEvent] = useState(false);
  const [isFreeDelivery, setIsFreeDelivery] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [cooperateEvent, setCooperateEvent] = useState({
    cooperate_original_price: null,
    cooperate_event_discount: null,
    cooperate_event_price: null,
    cooperate_price_description: null,
  });
  const exposureOptions = [
    { label: "노출", value: false },
    { label: "미노출", value: true },
  ];

  // 공유 리워드
  const [linkRewardPercentage, setLinkRewardPercentage] = useState({
    sender: null,
    receiver: null,
  });

  useEffect(() => {
    if (selectedRows.length > 0) {
      getOriginOptions();
    }
  }, [selectedRows]);

  // url에 id(cooperate_id)가 있으면 공구 수정
  useEffect(() => {
    if (match.params.id && match.params.influencerId) {
      setIsEdit(Boolean(match.params.id && match.params.influencerId));
      getCooperateProductInfo();
    } else {
      initInputs();
    }
  }, [match.params.id]);

  const getOriginOptions = async () => {
    let product = selectedRows[0];
    const param = {
      product_id: product?.product_id,
      exceptOptions: "",
    };
    const res = await productApi.readProductOptionList(param);
    if (res.code === 200) {
      let list = res.result.productItemOptionList.filter((item) => {
        return !item.terminated_status && !item.is_admin;
      });
      if (list.length > 0) {
        setOptionList(list);
      } else {
        setOptionList([]);
      }
    }
  };

  /**
   * 저장하기 -> 밸리데이션
   */
  const submitValidation = () => {
    if (selectInfluencer.id === 0) {
      window.alert("인플루언서를 선택해주세요.");
      return false;
    } else if (selectedRows.length === 0) {
      window.alert("공동구매 상품을 선택해주세요.");
      return false;
    } else if (productOptions.length === 0) {
      window.alert("옵션을 추가해주세요.");
      return false;
    } else if (productOptions.filter((item) => item.price_2 === 0).length > 0) {
      window.alert("공구가가 0인 옵션이 있습니다.");
      return false;
    } else if (
      productOptions.some((item) => {
        const hasTagName = item.tag_name?.trim();
        const hasBgColor = item.tag_background_color?.trim();
        const hasTextColor = item.tag_text_color?.trim();
        if (!hasTagName) return false;
        return (
          (hasBgColor && !hasBgColor.startsWith("#")) ||
          (hasTextColor && !hasTextColor.startsWith("#"))
        );
      })
    ) {
      window.alert("태그 배경색과 태그 글자색은 '#'으로 시작해주세요.");
      return false;
    } else if (cooperateTitle.trim() === "") {
      window.alert("이벤트 제목을 입력해주세요.");
      return false;
    } else if (cooperateTagsList.length === 0) {
      window.alert("이벤트 태그를 추가해주세요.");
      return false;
    } else if (cooperateEvent.cooperate_original_price === null) {
      window.alert("판매가를 입력해주세요.");
      return false;
    } else if (cooperateEvent.cooperate_event_discount === null) {
      window.alert("할인률을 입력해주세요.");
      return false;
    } else if (cooperateEvent.cooperate_event_price === null) {
      window.alert("할인가를 입력해주세요.");
      return false;
    } else if (isHidden === null) {
      window.alert("노출 여부를 선택해주세요.");
      return false;
    }
    return true;
  };

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        "해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?",
      )
    ) {
      setIsLoading(false);
      // window.location.reload();
      history.push("/product/cooperate_view");
    }
  };

  /**
   * 공동구매 데이터 저장하기
   * 1) product_item_cooperate 생성
   * 2) participate_cooperate 해당 인플루언서로 생성
   * 3) 공동구매용 옵션 생성
   * 4) 공동구매용 쿼리 생성
   * @returns {Promise<void>}
   */
  const onSubmitCooperate = async () => {
    let valid = submitValidation();
    if (valid) {
      handleProductItemCooperate();
    }
  };

  /**
   * 1) product_item_cooperate 생성/수정
   * 2) participate_cooperate 해당 인플루언서로 생성
   * @returns {Promise<boolean>}
   * @constructor
   */
  const handleProductItemCooperate = async () => {
    setIsLoading(true);
    setStep(1);
    let param = {
      influencer_id: selectInfluencer.id,
      cooperate_start_date: searchOptions.startDate,
      cooperate_end_date: searchOptions.endDate,
      commission_rate: cooperate.commission_rate,
      dy_commission_include: cooperate.dy_commision_include,
      product_id: selectedRows[0].product_id,
      target_id: selectedRows[0].target_id,
      is_participation: true,
      is_sold_out: false,
      title: cooperateTitle,
      isFirstPurchaseBonusEvent: isFirstPurchaseEvent ? true : false,
      isFreeDelivery: isFreeDelivery ? true : false,
      eventType: "TIME_DEAL",
      tags: cooperateTagsList.map((tag) => ({
        title: tag.title,
        id: null,
        textColor: tag.textColor,
        backgroundColor: tag.backgroundColor,
      })),
      is_hidden: isHidden,
      cooperate_price_description: cooperateEvent.cooperate_price_description,
      cooperate_original_price: Number(cooperateEvent.cooperate_original_price),
      cooperate_event_discount: Number(cooperateEvent.cooperate_event_discount),
      cooperate_event_price: Number(cooperateEvent.cooperate_event_price),
      referral_commission_rate: Number(linkRewardPercentage.sender) || 0,
      referred_commission_rate: Number(linkRewardPercentage.receiver) || 0,
    };
    if (productItemCooperate.id) {
      param.id = productItemCooperate.id;
    }

    const res = await CooperateApi.postProductItemCooperate(param);
    if (res.code === 200) {
      setProductItemCooperate(res.result.productItemCooperate);
      setParticipationCooperate(res.result.participationCooperate);
      setCooperateTagsList(res.result.cooperationEventTagList);
      createCooperateOption(res.result.productItemCooperate);
    } else {
      setStep(0);
      setIsLoading(false);
    }

    return res.code === 200;
  };

  /**
   * 3) 공동구매용 옵션 생성
   * 공동구매 옵션 생성
   * @returns {Promise<void>}
   */
  const createCooperateOption = async (product) => {
    setStep(3);
    let list = productOptions
      .map((item) => {
        if (item.id) {
          return {
            ...item,

            // 태그 추가
            tag_background_color:
              item.tag_name && item.tag_name.trim() !== ""
                ? item.tag_background_color
                : item.tag_background_color,
            tag_text_color:
              item.tag_name && item.tag_name.trim() !== ""
                ? item.tag_text_color || "#FFFFFF"
                : item.tag_text_color,
          };
        } else {
          return {
            ...item,
            option_id: optionList[0].id,
            product_id: selectedRows[0].product_id,
            target_id: selectedRows[0].target_id,
            cooperate_id: product.id,

            // 태그 추가
            tag_background_color:
              item.tag_name && item.tag_name.trim() !== ""
                ? item.tag_background_color
                : item.tag_background_color,
            tag_text_color:
              item.tag_name && item.tag_name.trim() !== ""
                ? item.tag_text_color || "#FFFFFF"
                : item.tag_text_color,
          };
        }
      })
      .sort((a, b) => a.price_2 - b.price_2);

    list[0]["price_1"] = cooperate.price_1;

    let param = {
      product_id: selectedRows[0].product_id,
      target_id: selectedRows[0].target_id,
      productItemOptionCooperateList: list,
    };

    const res = await CooperateApi.postProductItemOptionCooperate(param);
    if (res.code === 200) {
      setProductOptions(res.result);
      checkNotDuplication();
      setIsLoading(false);
    } else {
      setStep(0);
      setIsLoading(false);
    }
  };

  /**
   * 4) 공동구매용 쿼리 생성
   * 4-1. 쿼리 중복 여부 체크
   * @returns {Promise<{result, query: string}>}
   * true : 중복 아님, false: 중복
   */
  const checkNotDuplication = async () => {
    setStep(3);
    let checkTimes = 0;
    let text = "";
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let isValid = false;
    while (!isValid) {
      checkTimes++;
      text = "";
      for (let i = 0; i < 8; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      let param = {
        user_id: selectInfluencer.id,
        product_id: selectedRows[0].product_id,
        query: text,
        isCooperate: true,
      };
      const res = await api.checkDuplicateProductLink(param);
      if (res.data.code === 200) {
        if (res.data.result) {
          setReturnQuery({
            result: res.data.result,
            query: text,
          });
          isValid = true;
        }
      } else {
        setStep(1);
        setIsLoading(false);
      }
      if (checkTimes > 9) {
        setStep(0);
        setIsLoading(false);
        break;
      }
    }
  };

  useEffect(() => {
    if (
      Object.prototype.hasOwnProperty.call(returnQuery, "result") &&
      Object.prototype.hasOwnProperty.call(returnQuery, "query")
    ) {
      createRandomQuery();
    }
  }, [returnQuery]);

  /**
   * 4) 공동구매용 쿼리 생성
   * 4-2. 쿼리 생성
   * @returns {Promise<void>}
   */
  const createRandomQuery = async () => {
    const { result, query } = returnQuery;
    const dataQuery = !!selectedRows[0]?.product_link;
    if (!dataQuery && result) {
      let param = {
        cooperate_id: productItemCooperate.id,
        influencer_id: selectInfluencer.id,
        product_id: selectedRows[0].product_id,
        query: query,
      };
      const res = await CooperateApi.issueProductLinkCooperate(param);
      if (res?.code === 200) {
        setCooperateQuery(res.result.query);
        setIsLoading(false);
        setStep(1);
        window.scrollTo({ top: 0, behavior: "smooth" });
        Swal.fire({
          title: "성공적으로 저장되었습니다.",
          text: `www.dangyoung.com/products/group_buying/${selectedRows[0]?.target_id}?query=${cooperateQuery}`,
          customClass: "custom-alert",
          confirmButtonColor: "#117ffa",
          confirmButtonText: "확인",
        });
      } else {
        setIsLoading(false);
        setStep(1);
        Swal.fire({
          title: "공동구매 등록에 실패하였습니다\n다시 시도해주세요.",
          customClass: "custom-alert",
          confirmButtonColor: "#117ffa",
          confirmButtonText: "확인",
        });
      }
    } else {
      setIsLoading(false);
      setStep(1);
    }
  };

  const successLinkAlert = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    Swal.fire({
      title: "성공적으로 저장되었습니다.",
      text: `www.dangyoung.com/products/group_buying/${selectedRows[0]?.target_id}?query=${cooperateQuery}`,
      customClass: "custom-alert",
      confirmButtonColor: "#117ffa",
      confirmButtonText: "확인",
    });
  };

  const onNewCooperateRegisterBtnClick = () => {
    if (
      window.confirm(
        "확인을 누르면 현재 페이지가 새로고침 되고 지금까지 작성한 기록들이 전부 사라집니다.\n공동구매를 새로 등록하시겠습니까?",
      )
    ) {
      setIsLoading(false);
      window.location.reload();
      // history.go(-1);
    }
  };

  /**
   * 수정하려는 공구 상품 정보 가져오기
   * @returns {Promise<void>}
   */
  const getCooperateProductInfo = async () => {
    setIsLoading(true);
    try {
      const param = {
        cooperateId: match.params.id,
        influencerId: match.params.influencerId,
      };
      const res = await cooperateApi.getProductItemCooperateById(param);
      if (res.code === 200) {
        const sortedCooperateOptionList = res.result.cooperateOptionList.sort(
          (a, b) => a.price_2 - b.price_2,
        );
        setSelectInfluencer({
          id: res.result.influencer_id,
          nick_name: res.result.name,
        });
        setSelectedRows([
          {
            product_id: res.result.product_id,
            target_id: res.result.target_id,
            product_category_name: res.result.product_category_name,
            product_brand_name: res.result.product_brand_name,
            product_name: res.result.product_name,
          },
        ]);
        setSelectedRowKeys([res.result.product_id]);
        setSearchOptions({
          startDate: moment(res.result.cooperate_start_date),
          endDate: moment(res.result.cooperate_end_date),
        });
        setStandardSearchOptions({
          startDate: moment(res.result.cooperate_start_date),
          endDate: moment(res.result.cooperate_end_date),
        });
        setCooperate({
          commission_rate: res.result.commission_rate,
          dy_commision_include: res.result.dy_commission_include,
          price_1: sortedCooperateOptionList[0]?.price_1,
        });
        setCooperateEvent({
          cooperate_original_price: res.result.cooperate_original_price || 0,
          cooperate_event_discount: res.result.cooperate_event_discount || 0,
          cooperate_event_price: res.result.cooperate_event_price || 0,
          cooperate_price_description:
            res.result.cooperate_price_description || "",
        });
        setProductOptions(sortedCooperateOptionList);
        setCooperateQuery(res.result.purchase_url);
        setIsSoldOut(res.result.is_sold_out);
        setIsHidden(res.result.is_hidden);
        setCooperateTitle(res.result.title);
        setCooperateTagsList(res.result.tagList);
        setIsFirstPurchaseEvent(
          res.result.isFirstPurchaseBonusEvent ? true : false,
        );
        setIsFreeDelivery(res.result.isFreeDelivery ? true : false);
        setLinkRewardPercentage({
          sender: res.result.referral_commission_rate,
          receiver: res.result.referred_commission_rate,
        });
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
        // history.push(`/product/cooperate_view`);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("getProductItemCooperateById read error", error);
    }
  };

  /**
   * 마감여부 체크 / 체크해제
   */
  const onIsSoldOutChange = () => {
    setIsSoldOut((prev) => !prev);
  };

  const handleExposureChange = (e) => {
    setIsHidden(e.target.value);
  };

  /**
   * 공동구매 수정하기 (마감여부, 공구기간, 매출연동수수료, 공구옵션)
   * @returns {Promise<void>}
   */
  const onEditCooperate = async () => {
    setIsLoading(true);
    const isValid = submitValidation();
    if (!isValid) {
      setIsLoading(false);
      return;
    }
    try {
      let newOptionList = productOptions
        .map((item) => {
          if (item.id) {
            return {
              ...item,
              price_1: null,

              // 태그 추가
              tag_background_color:
                item.tag_name && item.tag_name.trim() !== ""
                  ? item.tag_background_color
                  : item.tag_background_color,
              tag_text_color:
                item.tag_name && item.tag_name.trim() !== ""
                  ? item.tag_text_color || "#FFFFFF"
                  : item.tag_text_color,
            };
          } else {
            return {
              ...item,
              id: null,
              price_1: null,
              option_id: optionList[0].id,
              product_id: selectedRows[0].product_id,
              target_id: selectedRows[0].target_id,
              cooperate_id: match?.params?.id,

              // 태그 추가
              tag_background_color:
                item.tag_name && item.tag_name.trim() !== ""
                  ? item.tag_background_color
                  : item.tag_background_color,
              tag_text_color:
                item.tag_name && item.tag_name.trim() !== ""
                  ? item.tag_text_color || "#FFFFFF"
                  : item.tag_text_color,
            };
          }
        })
        .sort((a, b) => a.price_2 - b.price_2);
      newOptionList[0].price_1 = cooperate.price_1;

      const param = {
        id: match?.params?.id,
        influencer_id: selectInfluencer.id,
        created_by: user.id === 724 ? 1 : user.id,
        cooperate_start_date: searchOptions.startDate,
        cooperate_end_date: searchOptions.endDate,
        commission_rate: cooperate.commission_rate,
        dy_commission_include: cooperate.dy_commision_include,
        is_sold_out: isSoldOut,
        productItemOptionCooperateList: newOptionList,
        title: cooperateTitle,
        tags: cooperateTagsList,
        isFirstPurchaseBonusEvent: isFirstPurchaseEvent ? true : false,
        isFreeDelivery: isFreeDelivery ? true : false,
        is_hidden: isHidden,
        cooperate_price_description: cooperateEvent.cooperate_price_description,
        cooperate_original_price: Number(
          cooperateEvent.cooperate_original_price,
        ),
        cooperate_event_discount: Number(
          cooperateEvent.cooperate_event_discount,
        ),
        cooperate_event_price: Number(cooperateEvent.cooperate_event_price),
        referral_commission_rate: Number(linkRewardPercentage.sender) || 0,
        referred_commission_rate: Number(linkRewardPercentage.receiver) || 0,
      };

      console.log("param", param);

      const res = await cooperateApi.editProductItemCooperate(param);
      console.log("res", res);

      if (res.code === 200) {
        setIsLoading(false);
        // window.scrollTo({ top: 0, behavior: "smooth" });
        Swal.fire({
          title: "성공적으로 저장되었습니다.",
          customClass: "custom-alert",
          confirmButtonColor: "#117ffa",
          confirmButtonText: "확인",
        }).then((res) => {
          if (res.isConfirmed) {
            history.push(`/product/cooperate_view`);
            // getCooperateProductInfo();
          }
        });
      } else {
        setIsLoading(false);
        Swal.fire({
          title: "공동구매 수정에 실패하였습니다.\n다시 시도해주세요.",
          customClass: "custom-alert",
          confirmButtonColor: "#117ffa",
          confirmButtonText: "확인",
        }).then((res) => {
          if (res.isConfirmed) {
            history.push(`/product/cooperate_view`);
            // getCooperateProductInfo();
          }
        });
      }
    } catch (e) {
      setIsLoading(false);
      console.log("[Error] ", e);
    } finally {
      setIsLoading(false);
    }
  };

  const initInputs = () => {
    setSelectInfluencer({
      id: 0,
      nick_name: "",
    });
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setSearchOptions({
      startDate: moment().hour(10).minute(0).seconds(0),
      endDate: moment().add(7, "day").hour(22).minute(0).seconds(0),
    });
    setCooperate({
      commission_rate: 0,
      dy_commision_include: true,
      price_1: null,
    });
    setProductOptions([
      {
        option_title: "[N%, 1+1] N박스 (N개월분)",
        price_2: 0,
        option_quantity: 1,
        conversion_price_per_unit: null,
        quantity: 999,

        // 태그 추가
        tag_name: null,
        tag_background_color: null,
        tag_text_color: null,
      },
    ]);
    setOptionList([]);
    setProductItemCooperate({});
    setParticipationCooperate({});
    setReturnQuery({});
    setCooperateQuery(null);
    setIsFirstPurchaseEvent(false);
    setIsFreeDelivery(false);
    setStep(0);
    setIsLoading(false);
  };

  const onIsFirstPurchaseEventChange = (e) => {
    setIsFirstPurchaseEvent(e.target.checked);
  };

  const onIsFreeDeliveryChange = (e) => {
    setIsFreeDelivery(e.target.checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // 가격 필드 (11자리 제한)
    if (
      (name === "cooperate_original_price" ||
        name === "cooperate_event_price") &&
      String(value).length > 11
    ) {
      return;
    }

    // 할인율 제한 (0~100%)
    if (
      name === "cooperate_event_discount" &&
      (Number(value) < 0 || Number(value) > 100)
    ) {
      return;
    }

    // 가격 설명란 제한 (10자 이내)
    if (name === "cooperate_price_description" && value.length > 10) {
      return;
    }

    setCooperateEvent((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLinkRewardChange = (e) => {
    const { name, value } = e.target;

    if (name === "receiver" && (Number(value) < 0 || Number(value) > 100)) {
      return;
    }

    if (name === "sender" && (Number(value) < 0 || Number(value) > 100)) {
      return;
    }
    setLinkRewardPercentage((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div style={{ position: "relative" }}>
      {/*<ContentHeaderComponent title="공동구매 등록" />*/}
      <ContentHeaderComponent
        title={isLoading ? null : isEdit ? "공동구매 수정" : "공동구매 등록"}
      />
      <div className="product-register-wrap" style={{ padding: "20px 0" }}>
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              border: "solid 1px #ced4da",
              borderRadius: "5px",
              backgroundColor: "white",
              padding: "1em 1.5em",
              display: "flex",
              alignItems: "center",
              gap: "1em",
              boxShadow: "0 0px 6px 0 rgba(0, 0, 0, 0.16)",
              zIndex: 9,
            }}
          >
            <Spin style={{ lineHeight: 1 }} />
            {step > 0 && (
              <p style={{ margin: 0, whiteSpace: "pre-line" }}>
                {step === 1
                  ? "공동구매 등록 중입니다."
                  : step === 2
                  ? "공동구매용 옵션을 등록 중입니다."
                  : "상품 링크를 생성 중입니다."}
              </p>
            )}
          </div>
        )}
        {/* 공동구매 링크 */}
        <Row
          className="product-register-border-box"
          id={"cooperate-link"}
          wrap={false}
        >
          <span className="product-register-box-title">공동구매 링크</span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
        >
          {cooperateQuery ? (
            <p
              className="cooperate-purchase-link"
              onClick={() => {
                // 공구 페이지 링크로 이동
                // window.open(
                // 	`https://www.dangyoung.com/products/group_buying/${selectedRows[0]?.target_id}/?query=${cooperateQuery}`,
                // 	"_blank"
                // );

                // 공구 페이지 링크 복사
                navigator.clipboard.writeText(
                  `https://www.dangyoung.com/products/group_buying/${selectedRows[0]?.target_id}/?query=${cooperateQuery}`,
                );
                alert("링크가 복사되었습니다.");
              }}
            >
              www.dangyoung.com/products/group_buying/
              {selectedRows[0]?.target_id}/?query={cooperateQuery}
            </p>
          ) : (
            <p style={{ color: "#868e96" }}>링크 미생성</p>
          )}
        </Row>
        {/* 마감여부 */}
        {isEdit && (
          <>
            <Row
              className="product-register-border-box"
              id={"cooperate-link"}
              wrap={false}
            >
              <span className="product-register-box-title">
                공동구매 마감 여부
              </span>
            </Row>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
            >
              <Checkbox checked={isSoldOut} onChange={onIsSoldOutChange}>
                마감
              </Checkbox>
            </Row>
          </>
        )}

        {/* 노출 여부 */}
        <>
          <Row
            className="product-register-border-box"
            id={"cooperate-link"}
            wrap={false}
          >
            <span className="product-register-box-title">
              공동구매 노출 여부
            </span>
            <span className="product-register-box-sign">*</span>
          </Row>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
          >
            <Radio.Group
              options={exposureOptions}
              onChange={handleExposureChange}
              value={isHidden}
              optionType="button"
              buttonStyle="solid"
            />
          </Row>
        </>

        {/* 이벤트 제목 */}
        <Row
          className="product-register-border-box"
          id={"cooperate-link"}
          wrap={false}
        >
          <span className="product-register-box-title">이벤트 제목</span>
          <span className="product-register-box-sign">*</span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
        >
          <Input
            value={cooperateTitle}
            placeholder="이벤트 제목을 입력하세요"
            onChange={(e) => setCooperateTitle(e.target.value)}
          />
        </Row>
        {/* 이벤트 태그 - 필수값 아니면 수정이 안 됨 */}
        {/* 이벤트 태그에는 제목, 글자 색상, 배경 색상을 지정할 수 있고, #000000 형식으로 입력해야 함 */}
        <Row
          className="product-register-border-box"
          id={"cooperate-link"}
          wrap={false}
        >
          <span className="product-register-box-title">이벤트 태그</span>
          <span className="product-register-box-sign">*</span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            width: "100%",
            height: "100%",
            marginBottom: 20,
            padding: "15px",
          }}
        >
          <CooperateTag
            cooperateTagsList={cooperateTagsList}
            setCooperateTagsList={setCooperateTagsList}
          />
        </Row>

        {/* 인플루언서 선택 */}
        <CooperatePickInfluencer
          isDisabled={isEdit}
          selectInfluencer={selectInfluencer}
          setSelectInfluencer={setSelectInfluencer}
        />
        {/* 공동구매 상품 선택 */}
        <CooperatePickProduct
          isDisabled={isEdit}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        {/* 공구 기간 */}
        <CooperatePeriod
          isEdit={isEdit}
          searchOptions={searchOptions}
          setSearchOptions={setSearchOptions}
          standardSearchOptions={standardSearchOptions}
        />
        {/* 공구 수수료 */}
        <CooperateFeeComponent
          cooperate={cooperate}
          setCooperate={setCooperate}
        />

        {/* 공유 리워드 */}
        <CooperateLinkRewardComponent
          linkRewardPercentage={linkRewardPercentage}
          handleLinkRewardChange={handleLinkRewardChange}
        />

        {/* 공동구매 상품 가격 정보 */}
        <CooperateProductPriceInformation
          cooperateEvent={cooperateEvent}
          setCooperateEvent={setCooperateEvent}
          handleChange={handleChange}
        />

        {/* 공동 구매 옵션*/}
        <CooperateOptionComponent
          product={selectedRows[0]}
          cooperate={cooperate}
          setCooperate={setCooperate}
          productOptions={productOptions}
          setProductOptions={setProductOptions}
          setExampleShow={setExampleShow}
          setExampleTitle={setExampleTitle}
          optionList={optionList}
        />

        {/* 첫 구매 이벤트인지 여부 */}
        <Row
          style={{ marginTop: 20 }}
          className="product-register-border-box"
          id={"cooperate-link"}
          wrap={false}
        >
          <span className="product-register-box-title">
            첫 구매 이벤트 여부
          </span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
        >
          <Checkbox
            checked={isFirstPurchaseEvent}
            onChange={onIsFirstPurchaseEventChange}
          >
            첫 구매 이벤트 여부
          </Checkbox>
        </Row>

        {/* 무료 배송인지 여부 */}
        <Row
          className="product-register-border-box"
          id={"cooperate-link"}
          wrap={false}
        >
          <span className="product-register-box-title">무료 배송 여부</span>
        </Row>
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ borderTop: 0, width: "100%", marginBottom: 20 }}
        >
          <Checkbox checked={isFreeDelivery} onChange={onIsFreeDeliveryChange}>
            무료 배송 여부
          </Checkbox>
        </Row>

        {/* 예시 모달 */}
        <Modal
          className="related-product-modal-wrap"
          width={exampleTitle.id === "promotion" ? "45%" : "60%"}
          title={exampleTitle.title}
          visible={exampleShow}
          onCancel={() => setExampleShow(!exampleShow)}
          footer={null}
        >
          <img
            alt={exampleTitle.title}
            src={`/assets/images/example/${exampleTitle.id}.png`}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          {exampleTitle.id === "cooperate_price_1" && (
            <div
              style={{
                border: "solid 1px #ced4da",
                padding: "1rem",
                marginTop: "1rem",
              }}
            >
              <p style={{ color: "red" }}>
                * 미 입력시에는 기존에 표기되던 금액으로 표기됩니다.
              </p>
              <img
                alt={exampleTitle.title}
                src={`/assets/images/example/${exampleTitle.id}-2.png`}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          )}
        </Modal>
      </div>
      <div className="product-register-fixed-footer">
        {!isLoading &&
          !match.params.id &&
          !match.params.influencerId &&
          cooperateQuery && (
            <Button
              className="product-register-button save"
              onClick={onNewCooperateRegisterBtnClick}
              loading={isLoading}
              style={{ width: "fit-content", marginRight: "1em" }}
            >
              {isLoading ? null : "새 공구 등록하기"}
            </Button>
          )}
        <Button
          className="product-register-button save"
          onClick={isEdit ? onEditCooperate : onSubmitCooperate}
          loading={isLoading}
          disabled={!!cooperateQuery && !isEdit}
        >
          {isLoading ? null : isEdit ? "수정하기" : "저장하기"}
        </Button>
        <Button
          className="product-register-button cancel"
          onClick={cancelBtnClick}
        >
          취소
        </Button>
      </div>
    </div>
  );
};

export default CooperateRegisterComponent;
